import { useTranslation } from 'react-i18next';
import React, { useMemo } from 'react';
import type { FeedArticle } from '@/views/Stream/types';
import { useCurrentAddressInfo } from '@/hooks';

import { ActionContent } from './Actions';
import styles from './index.module.scss';

type ActionListProps = {
  article: FeedArticle;
};

export const ActionList = ({ article }: ActionListProps) => {
  const { t } = useTranslation();

  const quest = article.quest!;

  const { isVerified } = useCurrentAddressInfo();

  const disableTip = useMemo(() => {
    if (!isVerified) {
      return;
    }
    if (quest.status !== 'active') {
      return t('QuestCard_Task.closed');
    }

    if (!quest.has_permission) {
      return t('QuestCard_Task.noeligible');
    }
  }, [isVerified, quest.status, quest.has_permission, t]);

  return (
    <div className={styles.actionList}>
      <div className={styles.actionTitle}>{t('AccountHistory.wchdg6')}</div>
      {article.quest!.actions?.map((x, i) => {
        const Tpl = ActionContent[x.type];
        return (
          <>
            {Tpl ? (
              <Tpl
                articleId={article.id}
                data={x}
                key={x.id}
                disableTip={disableTip}
                isCompleted={quest.is_completed}
              />
            ) : null}
          </>
        );
      })}
    </div>
  );
};
